/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Chat_GInputs */

const en_mk_tut_chat_g = /** @type {(inputs: Mk_Tut_Chat_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not everything deserves an issue. For the small things, talk in the division channel — and the agent can join that same conversation.`)
};

const id_mk_tut_chat_g = /** @type {(inputs: Mk_Tut_Chat_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak semua hal pantas jadi issue. Untuk yang kecil, bicarakan di channel divisi — dan agen bisa ikut di percakapan yang sama.`)
};

/**
* | output |
* | --- |
* | "Not everything deserves an issue. For the small things, talk in the division channel — and the agent can join that same conversation." |
*
* @param {Mk_Tut_Chat_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_chat_g = /** @type {((inputs?: Mk_Tut_Chat_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Chat_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_chat_g(inputs)
	return en_mk_tut_chat_g(inputs)
});